import { render, staticRenderFns } from "./rewardTwoPlusGiftEdit_bak.vue?vue&type=template&id=f387c2b2&scoped=true&"
import script from "./rewardTwoPlusGiftEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardTwoPlusGiftEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f387c2b2",
  null
  
)

export default component.exports